// extracted by mini-css-extract-plugin
export default {"card":"CatalogCard_card__6W2HG","cardImg":"CatalogCard_cardImg__J+dz4"};